// Mississippi State's undergraduate majors (#2743). Read on 2026-10-01 from
// MSU's official Find a Major directory (majors.msstate.edu, linked from
// Undergraduate Admissions' Academics page), which lists every bachelor's
// program with its college and degree. The 2026-27 catalog
// (catalog.msstate.edu) describes programs in department prose rather than a
// list, so the directory is the list used. Changes from the directory: its
// eleven "Data Science: X" entries and six "Kinesiology - X" entries are
// concentrations of one B.S. each, folded into one major with the
// concentrations in a note; the Accelerated Law Pathway is a note on the
// Liberal Arts B.A.; the Shackouls Honors College "Cursus Honorum" is not a
// bachelor's major and is left out; the directory's "Bachelor in Business
// Administration in Business Administration" is written as Bachelor of
// Business Administration; Mathematics & Statistics, offered as a B.S. and a
// B.A. in Mathematics, is two lines; the ELX dual degree and International
// Business double degree sit under the college the directory names first.
// Degrees are written as the directory writes them, with the repeated major
// name dropped ("Bachelor of Science in Chemistry" -> "Bachelor of Science").
// The official major name "Artificial Intelligence" is kept as written.
// The KB's majors list was the starting point; the directory wins.
const majors = {
    "slug": "mississippi-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in MSU's official Find a Major directory, grouped by the college that offers it, with the degree it leads to. Concentrations are folded into their major. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Education, Leadership, and Communications",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Engineering Technology and Business",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agricultural Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Agronomy",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Animal and Dairy Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Culinology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Economics and Sustainability",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Science in Agricultural Systems",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Fashion Design and Merchandising",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Food Science, Nutrition and Health Promotion",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Horticulture",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "Bachelor of Landscape Architecture"
                },
                {
                    "name": "Landscape Contracting and Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Poultry Science",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Architecture, Art, and Design",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "Bachelor of Architecture"
                },
                {
                    "name": "Building Construction Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Fine Arts",
                    "degree": "Bachelor of Fine Arts",
                    "note": "In graphic design, photography or fine arts (ceramics, drawing, illustration, painting, printmaking and sculpture)."
                },
                {
                    "name": "Integrated Design and the Built Environment",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interior Design",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Clinical Laboratory Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Communication, Media & Theatre",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Criminology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Earth and Environmental Geosciences",
                    "degree": "Bachelor of Science in Geosciences"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Foreign Languages",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "General Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "Bachelor of Arts",
                    "note": "Also offered with an Accelerated Law Pathway."
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Meteorology",
                    "degree": "Bachelor of Science in Geosciences"
                },
                {
                    "name": "Microbiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Philosophy & Religion",
                    "degree": "Bachelor of Arts in Philosophy"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Political Science and Public Administration",
                    "degree": "Bachelor of Arts in Political Science"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "Bachelor of Accountancy"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Business Information Systems",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "International Business",
                    "degree": "Bachelor of Business Administration and Bachelor of Arts",
                    "note": "A B.B.A. in International Business with a B.A. in Foreign Languages, offered with the College of Arts and Sciences."
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Supply Chain Logistics",
                    "degree": "Bachelor of Business Administration"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Applied Behavior Analysis",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Educational Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Elementary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science",
                    "note": "Concentrations: Clinical Exercise Physiology, Neuromechanics, Physical Activity and Coaching, Physical Education and Coaching, Sport Administration, Strength and Conditioning."
                },
                {
                    "name": "Learning and User Experience Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music Education"
                },
                {
                    "name": "Music Performance",
                    "degree": "Bachelor of Music in Performance"
                },
                {
                    "name": "Secondary Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Special Education",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "James Worth Bagley College of Engineering",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil & Environmental Engineering",
                    "degree": "Bachelor of Science in Civil Engineering"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial and Systems Engineering and Business Administration (ELX dual degree)",
                    "degree": "B.S. and B.B.A.",
                    "note": "A B.S. in Industrial & Systems Engineering with a B.B.A. in Business Administration, offered with the College of Business."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Forest Resources",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Forestry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Natural Resource and Environmental Conservation",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sustainable Bioproducts",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Wildlife, Fisheries and Aquaculture",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Integrative Studies",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science",
                    "note": "Concentrations: Biomedical Informatics, Business Information Systems, Computational Agriculture and Natural Resources, Computational Intelligence, Geoinformatics, Marketing and Supply Chain Analytics, Psychoinformatics, Social Data Analytics, Sports Science, Statistical Modeling, Visualization and Visual Analytics for the Built Environment."
                },
                {
                    "name": "Tourism & Destination Development",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Professional and Continuing Studies",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Business Office Technology",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Professional Studies",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "Public Management",
                    "degree": "Bachelor of Applied Science"
                },
                {
                    "name": "University Studies",
                    "degree": "Bachelor of University Studies"
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "MSU Find a Major (majors.msstate.edu)",
                "url": "https://www.majors.msstate.edu/"
            },
            "majors": [
                {
                    "name": "Veterinary Medical Technology",
                    "degree": "Bachelor of Science"
                }
            ]
        }
    ]
};

export default majors;
